import { useState } from "react";
import Joi from "joi";
import { validateFormData } from "../../utils/validation";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { errorMsg, successMsg } from "../../utils/customFn";
import { API_ENDPOINTS } from "../../constants/endPoints";

import BasicProvider from "../../services/basicProvider";

const useForgetPasswordUtils = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ email: "" });
  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setFormErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Define the validation schema for the form
    const validationSchema = Joi.object({
      email: Joi.string()
        .email({ minDomainSegments: 2, tlds: { allow: ["com", "org", "net"] } })
        .required()
        .messages({
          "string.email": "Please enter a valid email address.",
          "any.required": "Email is required.",
        }),
    });

    const validationResponse = await validateFormData(
      formData,
      validationSchema
    );

    if (!validationResponse.status) {
      setFormErrors(validationResponse.errors);
      return;
    }

    try {
      setLoading(true);
      const url = API_ENDPOINTS.forget_password;
      const response = await new BasicProvider(url, navigate, true).postRequest(
        formData
      );
      if (response?.status) {
        successMsg(response?.message);
        setFormData({email:""})
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  return {
    formData,
    formErrors,
    loading,
    handleChange,
    handleSubmit,
  };
};

export default useForgetPasswordUtils;
